import React, { Component } from "react";
import '../css/table-responsive.css'
import '../css/dashboard.css'
import LoadingWindow from "../components/LoadingWindow.js";

// Menu
import { Menu } from "../components/Menu/Menu.js";
import { getValueCookie } from "../services/cookieService.js";

export default class BlankLobby extends Component {

  constructor(props) {
    super(props);
    this.ModalLoading = React.createRef();
    this.state = {
      Refresh: false,
      CompanyLogo: getValueCookie('CompanyLogo'),
    };
  }

  render() {
    return (
      <div className="dash-page">
        <div id="GeneralPages" className="page container-fluid" style={{ paddingTop: '50px' }}>
          {/* Main menu */}
          <Menu Refresh={this.state.Refresh} Father={this} />

          {/* Loading modal */}
          <LoadingWindow ref={this.ModalLoading} />

          {/* Minimalist background with centered company logo */}
          <div
            style={{
              position: 'fixed',
              top: 60,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(180deg, #2448B8 0%, #16306f 100%)',
              zIndex: 0,
            }}
          >
            {this.state.CompanyLogo && (
              <img
                src={this.state.CompanyLogo}
                alt="Company"
                style={{
                  maxWidth: '40%',
                  maxHeight: '40%',
                  width: 'auto',
                  height: 'auto',
                  objectFit: 'contain',
                  opacity: 0.85,
                }}
              />
            )}
          </div>
        </div>
      </div>
    )
  }
}
